import { createUseStyles } from 'react-jss';
import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled, { css, CSSProp } from 'styled-components';

interface BrowsingCardWrapperStyledProps {
  $hasCrossSellPlan: boolean;
  $isAddedToCart: boolean;
}

const styles = {
  proposalsList: { display: 'flex', flexDirection: 'column', position: 'relative', minHeight: '20rem' },
  productLineSection: {
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    padding: '3.2rem 4rem',
    marginBottom: '3.2rem',
    '&:last-of-type': {
      marginBottom: '0rem',
    },
  },
  cartItemsContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  cartItemContent: {
    paddingTop: '4rem',
    display: 'flex',
    flexDirection: 'column',
  },
  cartItemContentInactiveBackdrop: {
    position: 'relative',
    '&::before': {
      zIndex: 4,
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: colors.neutral.white,
      cursor: 'not-allowed',
      opacity: '0.5',
    },
  },
  cartItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '2rem',
  },
  bcForm: { paddingLeft: '2rem' },
  alternativeText: {
    font: {
      size: '2.4rem',
      lineHeight: '3.2rem',
      weight: 700,
    },
    display: 'flex',
    margin: '2rem auto 2rem 55%',
    color: colors.neutral[900],
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };

export const ProposalCardWrapperStyled = styled.div<BrowsingCardWrapperStyledProps>`
  display: flex;
  flex-direction: column;
  flex: 2 1 55%;
  border-radius: 10px;
  background-color: ${colors.neutral.white};

  ${({ $hasCrossSellPlan, $isAddedToCart }): CSSProp =>
    ($hasCrossSellPlan && $isAddedToCart) || $isAddedToCart
      ? css`
          border-width: 4px 4px 4px 16px;
          border-style: solid;
          border-color: ${colors.blue[600]};
        `
      : css`
          border: 1px solid ${colors.neutral[300]};
        `}

  /* The current Proposal card does not support custom styling and will be fully redesigned soon. */        & > :last-child {
    border-radius: 0 0 10px 10px;
    border: none;
    background-color: unset;
    padding: ${({ $isAddedToCart }): string => ($isAddedToCart ? '2rem 1.6rem' : '2.4rem 3.2rem')};
  }
`;

export const CrossSellPlanLabelStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  ${typography.bold[14]}
  color: ${colors.purple[600]};
  background-color: ${colors.purple[100]};
  padding: 1rem;
  border-bottom: 1px solid ${colors.purple[600]};
  border-radius: 10px 10px 0 0;
`;
